module.exports = __webpack_public_path__ + "static/media/crocodile(17).372911b5.PNG";